import { render, staticRenderFns } from "./highThreshold-editor.vue?vue&type=template&id=026888c0&scoped=true&"
import script from "./highThreshold-editor.vue?vue&type=script&lang=js&"
export * from "./highThreshold-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "026888c0",
  null
  
)

export default component.exports